var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading_container"},[_c('div',{staticClass:"mask"}),_c('a-spin',{attrs:{"tip":_vm.loadingTips}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }